import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { ReportFilterFacade, ReportViewerFacade, ReportDbtMetadataFacade } from '@mode/report-viewer/domain';
import { ViewDataModalFacade, VirtualScrollFacade } from '@mode/reports/domain';

export const DowngradedReportViewerDomainModule = angular
  .module('downgraded-report-viewer-domain', [])
  .service('ReportFilterFacade', downgradeInjectable(ReportFilterFacade))
  .service('VirtualScrollFacade', downgradeInjectable(VirtualScrollFacade))
  .service('ReportViewerFacade', downgradeInjectable(ReportViewerFacade))
  .service('ReportDbtMetadataFacade', downgradeInjectable(ReportDbtMetadataFacade))
  .service('ViewDataModalFacade', downgradeInjectable(ViewDataModalFacade)).name;
